import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export const BrapiSyncPath = {
    Connections: 'connections',
    Program: 'program',
    EntitySelector: 'entity-selector',
    Germplasm: 'germplasm',
    Trial: 'trial',
    Study: 'study',
    ObservationUnit: 'observation-unit',
    Variable: 'variable',
    Observation: 'observation',
} as const;

export type BrapiSyncPath = typeof BrapiSyncPath[keyof typeof BrapiSyncPath];

@Injectable()
export class BrapiSyncService {



    constructor(private router: Router) { }

    navigateToPageAndReloadTo(path: BrapiSyncPath) {
        this.router.navigate(['/', 'brapi-sync'], {
            queryParamsHandling: 'merge', onSameUrlNavigation: 'reload' }).then(() => {
            this.router.navigate(['/', 'brapi-sync', { outlets:{ 'brapi-sync-outlet': path } }], { queryParamsHandling: 'merge', onSameUrlNavigation: 'reload' });
        });
    }

    navigateToPage(path: BrapiSyncPath) {
        this.router.navigate(['/', 'brapi-sync', { outlets:{ 'brapi-sync-outlet': path } }], { queryParamsHandling: 'merge', onSameUrlNavigation: 'reload' });
    }
}


